import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getRemainingSMS, getSMSStatistics } from 'actions/sms';
import { DataList, Spinner } from 'UI';
import Block, { BlockHeader, BlockContent } from "UI/Elements/Block";
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { translate } from '@haldor/ui';

var SMSAdmin = /*#__PURE__*/function (_Component) {
  _inherits(SMSAdmin, _Component);

  var _super = _createSuper(SMSAdmin);

  function SMSAdmin() {
    var _this;

    _classCallCheck(this, SMSAdmin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getRemainingSMS();

      _this.props.getSMSStatistics();
    });

    _defineProperty(_assertThisInitialized(_this), "renderSchoolRow", function (school) {
      var statistic = null;

      if (_this.props.statistics != null) {
        statistic = _this.props.statistics.schools.find(function (_school) {
          return _school.schoolId == school.id;
        });
      }

      return /*#__PURE__*/React.createElement(RowItem, {
        key: school.id
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Name')
      }, school.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Sms-balance')
      }, statistic != null ? statistic.totalBoughtAmount - statistic.totalSMSSent : null), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Sent sms')
      }, statistic != null ? statistic.totalSMSSent : null));
    });

    return _this;
  }

  _createClass(SMSAdmin, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var schools = this.props.currentUser.schools;

      if (schools != null) {
        schools.sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DataList, {
        data: schools,
        renderRow: this.renderSchoolRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results')));
        }
      }));
    }
  }]);

  return SMSAdmin;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    remaining: state.SMS.remaining,
    statistics: state.SMS.statistics
  };
}

export default connect(mapStateToProps, {
  getRemainingSMS: getRemainingSMS,
  getSMSStatistics: getSMSStatistics
})(SMSAdmin);